import React from 'react'
import {FloatingArrow} from '@floating-ui/react'
import {usePopoverContext} from './PopoverContext'

const PopoverArrow = () => {
    const {context, arrowRef} = usePopoverContext()
    return (
        <FloatingArrow
            ref={arrowRef}
            context={context}
            className="popover-new__arrow"
            fill="white"
            width={14}
            height={7}
        />
    )
}

export default PopoverArrow
